define(['underscore', './_Augment'], (_, Augment)=> {
    const METADATA_CLASS = 'edge.aspects.validation.dto.VisibilityAndRequirednessRuleDTO';

    /** Creates a new "Field is required" aspect. */
    function create(expressionLanguage) {
        function getAllRules(compilationContext, node, nodeMetadata, ancestorChain) {
            return Augment.collectRules(compilationContext, node, nodeMetadata, ancestorChain, METADATA_CLASS);
        }

        function compileRule(compilationContext, rule) {
            const visibilityExpr = compilationContext.compile(rule.data.expression);
            const messageExpr = compilationContext.compile(rule.data.message);

            return {
                'shouldApply': rule.shouldApply,
                'status': visibilityExpr,
                'message': messageExpr
            };
        }

        function combineRules(rules) {
            return {
                'visible': (v, pv, ctx)=> {
                    return rules.every((rule)=> {
                        return !rule.shouldApply() || rule.status(v, pv, ctx) !== 'NOT_SET';
                    });
                },
                'required': (v, pv, ctx)=> {
                    return rules.some((rule)=> {
                        return rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED';
                    });
                },
                'requirednessMessages': (v, pv, ctx)=> {
                    return rules.filter((rule)=> {
                        return rule.shouldApply() && rule.status(v, pv, ctx) === 'REQUIRED';
                    }).map((rule)=> {
                        return rule.message(v, pv, ctx);
                    });
                }
            };
        }

        return {
            'getAspectProperties': (currentViewModelNode, currentMetadataNode, ancestorChain)=> {
                const compilationContext = expressionLanguage.getCompilationContext(currentMetadataNode.xCenter);
                const rules = getAllRules(compilationContext, currentViewModelNode, currentMetadataNode, ancestorChain);
                const compiledRules = rules.map(_.partial(compileRule, compilationContext));
                const descriptor = combineRules(compiledRules);
                return {
                    'visible': {
                        'get': ()=> {
                            return descriptor.visible(
                                currentViewModelNode,
                                ancestorChain.parent,
                                currentViewModelNode.aspects.context);
                        }
                    },
                    'required': {
                        'get': ()=> {
                            return descriptor.required(
                                currentViewModelNode,
                                ancestorChain.parent,
                                currentViewModelNode.aspects.context);
                        }
                    },
                    '_requirednessMessages': {
                        'get': ()=> {
                            return descriptor.requirednessMessages(
                                currentViewModelNode,
                                ancestorChain.parent,
                                currentViewModelNode.aspects.context);
                        }
                    }
                };
            }
        };
    }

    return {
        create
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/viewmodel/aspects/Requiredness.js
 **/